import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { intervalToDuration } from 'date-fns'

import { Dialog } from 'shared/Dialog'
import { Text } from 'shared/Typography'

import {
  Container,
  Title,
  Image,
  YouTubeStyled,
  YouTubeCrutch,
  ImageContainer,
  Time,
} from './styles'
import { previews } from './assets'

const YoutubeItem = ({ videoId, views }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [title, setTitle] = useState('')
  const [time, setTime] = useState(0)

  const handleClick = () => {
    setIsOpen(true)
  }

  const onReady = (e) => {
    setTitle(e.target?.videoTitle)
    const { hours, minutes, seconds } = intervalToDuration({ start: 0, end: e.target?.playerInfo?.duration * 1000 })

    setTime(`${hours ? `${hours}:` : ''}${minutes}:${seconds}`)
  }

  return (
    <>
      <Container onClick={handleClick}>
        <ImageContainer>
          <Image
            src={previews[videoId]}
            alt={'icon'}
          />

          {time !== 0 && (
            <Time>
              {time}
            </Time>
          )}
        </ImageContainer>

        <YouTubeCrutch
          videoId={videoId}
          onReady={onReady}
        />

        <Title
          weight={'medium'}
          size={['18/24', '18/24', '18/24']}
          dangerouslySetInnerHTML={{ __html: title }}
        />

        <Text
          className='h-color-D50'
          size={['16/20', '16/20', '16/20']}
          dangerouslySetInnerHTML={{ __html: views }}
        />

      </Container>

      <Dialog setIsModalOpen={setIsOpen} isModalOpen={isOpen}>
        <YouTubeStyled
          videoId={videoId}
        />
      </Dialog>
    </>
  )
}
YoutubeItem.propTypes = {
  videoId: PropTypes.string.isRequired,
  views: PropTypes.string.isRequired,
}

export default YoutubeItem
